import type { PaymentMethodType } from '../entities/enums';
import type { StringTypeMap } from '../types';

const language = {
  en: 'en',
  id: 'id',
};
export default { language };

export const CURRENCY_MAP: StringTypeMap = {
  1: 'MYR',
  2: 'SGD',
  3: 'PHP',
  4: 'USD',
  7: 'IDR',
};

export const CURRENCY_TO_COUNTRY_MAP: StringTypeMap = {
  myr: 'MY',
  sgd: 'SG',
  php: 'PH',
  usd: 'MY',
  idr: 'ID',
};

export const PAYMENT_GATEWAY: StringTypeMap = {
  stripe: 'stripe',
  ['2c2p']: '2c2p',
};

export const PAGE_NAME = {
  UPGRADE_FLOW: {
    true: {
      PREPAID_BILLINGINFO_PAGE: 'JobAd:Upgrade:BillingInfo',
      PURCHASE_PACKAGES_CHECKOUT_PAGE: 'Purchase:Packages:Checkout',
    },
    false: {
      PREPAID_BILLINGINFO_PAGE: 'Purchase:BillingInfo:Prepaid',
      PURCHASE_PACKAGES_CHECKOUT_PAGE: 'Purchase:Packages:Checkout',
    },
  },
};

export const EVENTS = {
  UPGRADE_FLOW: {
    true: {
      PREPAID_CC_PURCHASE_CLICK: 'upgradeflow-credit-card-purchase-clicked',
      PREPAID_CHEQUE_PURCHASE_CLICK: 'upgradeflow-cheque-purchase-clicked',
      PREPAID_IDBT_PURCHASE_CLICK: 'upgradeflow-bank-transfer-purchase-clicked',
      PREPAID_IDOB_PURCHASE_CLICK: 'upgradeflow-onlinebanking-purchase-clicked',
      PREPAID_PAYNOWQR_PURCHASE_CLICK: 'upgradeflow-paynowqr-purchase-click',
      PREPAID_CC_PAY_NOW_CLICK: 'upgradeflow-credit-card-pay-now-clicked',
      PREPAID_CHEQUE_PAY_NOW_CLICK: 'upgradeflow-cheque-pay-now-clicked',
      PREPAID_IDBT_PAY_NOW_CLICK: 'upgradeflow-bank-transfer-pay-now-clicked',
      PREPAID_IDOB_PAY_NOW_CLICK: 'upgradeflow-onlinebanking-pay-now-click',
      PREPAID_PAYNOWQR_PAY_NOW_CLICK: 'upgradeflow-paynowqr-pay-now-click',
    },
    false: {
      PREPAID_CC_PURCHASE_CLICK: 'Prepaid Credit Card Purchase Click',
      PREPAID_CHEQUE_PURCHASE_CLICK: 'Prepaid Cheque Purchase Click',
      PREPAID_IDBT_PURCHASE_CLICK: 'Prepaid Bank Transfer Purchase Click',
      PREPAID_IDOB_PURCHASE_CLICK: 'prepaid-onlinebanking-purchase-click',
      PREPAID_PAYNOWQR_PURCHASE_CLICK: 'Prepaid PayNow QR Purchase Click',
      PREPAID_CC_PAY_NOW_CLICK: 'prepaid-credit-card-pay-now-click',
      PREPAID_CHEQUE_PAY_NOW_CLICK: 'prepaid-cheque-pay-click',
      PREPAID_IDBT_PAY_NOW_CLICK: 'prepaid-bank-transfer-buy-click',
      PREPAID_IDOB_PAY_NOW_CLICK: 'prepaid-onlinebanking-pay-now-click',
      PREPAID_PAYNOWQR_PAY_NOW_CLICK: 'prepaid-paynowqr-pay-now-click',
    },
  },
  PAYMENT_TYPE_BANK_TRANSFER: 'Bank Transfer',
  PAYMENT_TYPE_CHEQUE: 'Cheque',
  PAYMENT_TYPE_CREDIT_CARD: 'Credit Card',
  PAYMENT_TYPE_PAYNOWQR: 'PayNowQR',
  PAYMENT_TYPE_ONLINE_BANKING: 'OnlineBanking',
  PREPAID_CC_SAVE_CARD_CLICK: 'prepaid-creditcard-save-card-click',
  PREPAID_CC_KEEP_CARD_CLICK: 'purchase-prepaid-creditcard-popup-keepcard',
  PREPAID_CC_DELETE_CARD_CLICK: 'prepaid-creditcard-delete-card',
  PREPAID_CC_DELETE_CARD_MODAL_POPUP:
    'purchase-prepaid-creditcard-popup-delete',

  PURCHASE_ERROR_MESSAGE_SHOWN: 'purchase-error-message-shown',
  PREPAID_CC_FORM_ERROR: 'purchase-prepaid-creditcard-form-error',
  PREPAID_CC_PURCHASE_FAIL_ERROR:
    'purchase-prepaid-creditcard-error-purchasefail',
  PREPAID_IDBT_PURCHASE_FAIL_ERROR: 'prepaid-id-bt-purchase-error-',
};

export const PREPAID_REMARK =
  'This invoice has been created by SiVA Prepaid Package (Jobstreet.com)';
export const ORDER_THROUGH_CODE_AGENA = 2;
export const PAYMENT_GATEWAY_STRIPE = 'stripe';

export const ABM_DEFAULT_ONLINE_TIMEOUT_DURATION = 7;
export const ABM_DEFAULT_OFFLINE_TIMEOUT_DURATION = 14;

export const TRACKJS_NAME = 'jobposting';
export const TRACKJS_TOKEN = 'c0dee68c9f294d4d8011e8e45b0a74ec';

export const paymentMethodsIn2c2p: PaymentMethodType[] = [
  'IdOnlineBanking',
  'IdEWallet',
  'PhOnlineBanking',
  'PhEWallet',
  'ThOnlineBanking',
  'IdQr',
  'HkEWallet',
  'PayPal',
];

export const TEST_RECORD_PAYMENT_TOKEN = 'test-record-payment-token';
export const TEST_RECORD_SUCCEEDED_STATUS = 'test-record-succeeded';
